import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  resultDiv: {
    paddingTop: pxToRem(16),
  },
  cacheKeyList: {
    maxHeight: pxToRem(400),
    width: '102%',
  },
  deleteAll: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    marginTop: `${pxToRem(16)} !important`,
  },
  prefixInputBox: {
    width: pxToRem(310),
  },
  listAction: {
    height: pxToRem(24),
  },
  searchKeyBtn: {
    top: pxToRem(22),
    marginLeft: pxToRem(50),
    minWidth: `${pxToRem(140)} !important`,
  },
  flushAllLabel: {
    paddingTop: `${pxToRem(5)} !important`,
  },
  flushAllButton: {
    marginLeft: `${pxToRem(16)} !important`,
  },
  closeModal: {
    marginRIght: `${pxToRem(5)} !important`,
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cacheValue: {
    marginLeft: '20%',
  },
});
